/**
 * FeatureName tracks all the features for which we show messages in our product.
 */
export enum FeatureName {
  FEATURE_NAME_UNKNOWN = 'FEATURE_NAME_UNKNOWN',
  FIRST_ORDER_INCENTIVE = 'FIRST_ORDER_INCENTIVE',
  FIRST_ORDER_INCENTIVE_AUTO_EXTEND = 'FIRST_ORDER_INCENTIVE_AUTO_EXTEND',
  FIRST_ORDER_INCENTIVE_LAST_CHANCE = 'FIRST_ORDER_INCENTIVE_LAST_CHANCE',
  BLOCKED_CHECKOUT = 'BLOCKED_CHECKOUT',
  EXPIRED_CARD = 'EXPIRED_CARD',
  HOLIDAY_SPEND = 'HOLIDAY_SPEND',
  MARKET_COUNTDOWN = 'MARKET_COUNTDOWN',
  FAIRE_VALUES = 'FAIRE_VALUES',
  FAIRE_DIRECT_INCENTIVES = 'FAIRE_DIRECT_INCENTIVES',
  SPECIAL_HOLIDAY_NET90 = 'SPECIAL_HOLIDAY_NET90',
  OPENING_ORDER_INCENTIVES = 'OPENING_ORDER_INCENTIVES',
  AMEX_INCENTIVE = 'AMEX_INCENTIVE',
  WAREHOUSE_SALE = 'WAREHOUSE_SALE',
  EMPLOYEE_GRANTED_FREE_FREIGHT = 'EMPLOYEE_GRANTED_FREE_FREIGHT',
  OPEN_WITH_FAIRE = 'OPEN_WITH_FAIRE',
  POS_INTEGRATION = 'POS_INTEGRATION',
  REFERRAL_FOLLOWUP = 'REFERRAL_FOLLOWUP',
  MARKETPLACE_INCENTIVE = 'MARKETPLACE_INCENTIVE',
  PAYMENT_TERMS = 'PAYMENT_TERMS',
  DISCOVERY_TERMS = 'DISCOVERY_TERMS',
  FAIRE_PAY_CAMPAIGN = 'FAIRE_PAY_CAMPAIGN',
  FAIRE_SOURCE_CAMPAIGN = 'FAIRE_SOURCE_CAMPAIGN',
}
